export enum SignupFrom {
  web = "web",
  facebook = "facebook",
  apple = "apple",
  google = "google",
  app = "app",
}

export enum Status {
  active = "active",
  locked = "locked",
  deleted = "deleted",
}

export enum Role {
  seller = "seller",
  agent = "agent",
  owner = "owner",
  admin = "admin",
  all = "all",
}

export enum AbilityAction {
  create = "create",
  read = "read",
  update = "update",
  delete = "delete",
  manage = "manage",
}
